export type AppEnvironment = 'development' | 'homolog' | 'production'

const KNOWN_ENVIRONMENTS: AppEnvironment[] = ['development', 'homolog', 'production']

const isAppEnvironment = (value: string | undefined): value is AppEnvironment =>
  KNOWN_ENVIRONMENTS.includes(value as AppEnvironment)

export function resolveEnvironment(
  nodeEnv = process.env.NODE_ENV,
  appEnv = process.env.VUE_APP_ENV
): AppEnvironment {
  if (nodeEnv !== 'production') return 'development'

  return isAppEnvironment(appEnv) ? appEnv : 'production'
}

export function resolveApiHost(apiUrl = process.env.VUE_APP_API_URL): string {
  if (!apiUrl) return ''

  try {
    return new URL(apiUrl).host || apiUrl
  } catch {
    return apiUrl
  }
}

export const environment = resolveEnvironment()

export const isProduction = environment === 'production'

export const apiHost = resolveApiHost()
